import React, { useEffect, useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import { addTrailer, updateTrailer } from "../../services/trailerServices";
import {
  isNTMSUSer,
} from "../../utils/roleUtils";
import { useDispatch, useSelector } from "react-redux";
import {
  addTrailerData,
  setTrailerData,
} from "../../redux/trailer/trailerReducer";
import PrimaryDetails from "./PrimaryDetails";
import FormTabs from "../Commons/Layouts/FormTabs";
import { setFormPendingCompletion, setFormPendingFunction, setNotificationData } from "../../redux/global/globalReducer";
import dayjs from "dayjs";
import { updateFormDataOnExit } from "../../utils/formUtils";

function TrailerForm({
  isFormEdit = false,
  selectedTrailer = {},
  isFormHidden,
  toggleFormDisplay,
  setIsFormDirty,
  modal,
  setModal,
  toggle,
  focusOnOpenOrCloseButton,
}) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    reset,
    setFocus,
    control,
    formState
  } = useForm();
  const { dirtyFields, errors, isDirty } = formState;
  const accountId = useSelector((state) => state.auth.user.accountId);
  const userType = useSelector((state) => state.auth.user.userType);
  const accountState = useSelector((state) => state.account.selectedAccount);
  const isInitialRender = useRef(true);

  // form values
  setValue("trailerId", 0);
  setValue("accountId", accountId);

  // useEffects
  useEffect(() => {
    clearErrors();
  }, []);

  useEffect(() => {
    clearErrors();
    reset();

    if (!isFormHidden) {
      setTimeout(() => {
        setFocus("vin");
      }, 50);
    }
  }, [isFormHidden]);

  useEffect(() => {
    const updateForm = async () => {
      await updateFormDataOnExit(
        dispatch,
        !_.isEmpty(dirtyFields),
        setIsFormDirty,
        isFormEdit,
        _.isEmpty(errors),
        handleSubmit,
        onSubmit
      )
    }

    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    updateForm();
  }, [formState])

  const onSubmit = async (payload, keepAlive = false) => {
    let response = null;

    _.set(payload, "year", dayjs(payload.year).format("YYYY-MM-DD"));
    _.set(
      payload,
      "trailerFinancials.purchaseDate",
      dayjs(payload.trailerFinancials.purchaseDate).format("YYYY-MM-DD")
    );
    _.set(payload, "trailerFinancials.accountId", accountId);

    if (isFormEdit) {
      _.set(payload, "trailerId", selectedTrailer.trailerId);
      _.set(payload, "accountId", selectedTrailer.accountId);
      _.set(
        payload,
        "trailerFinancials.trailerFinancialsId",
        selectedTrailer.trailerFinancials.trailerFinancialsId
      );

      response = await updateTrailer(payload, keepAlive);
      dispatch(
        setNotificationData({
          type: `${response.ok ? "success" : "error"}`,
          message: `${response.ok ? "Success!" : "Error!"}`,
          description: `${response.ok ? "Successfully saved" : "Failed to save"
            } trailer.`,
        })
      );
    } else {
      _.set(payload, "trailerId", 0);
      _.set(payload, "trailerFinancials.trailerFinancialsId", 0);

      if (isNTMSUSer(userType)) {
        _.set(
          payload,
          "accountId",
          accountState.accountId != null ? accountState.accountId : accountId
        );
      } else {
        _.set(payload, "accountId", accountId);
      }
      response = await addTrailer(payload, keepAlive);
      dispatch(
        setNotificationData({
          type: `${response.ok ? "success" : "error"}`,
          message: `${response.ok ? "Success!" : "Error!"}`,
          description: `${response.ok ? "Successfully saved" : "Failed to save"
            } trailer.`,
        })
      );
    }

    if (response.ok) {
      const trailerData = await response.json();
      dispatch(
        isFormEdit ? setTrailerData(trailerData) : addTrailerData(trailerData)
      );

      if (isDirty) {
        setModal(false);
      }
      setIsFormDirty(false);
      dispatch(setFormPendingCompletion(false));
      reset({}, {keepValues: true});
      return true;
    }
    return false;
  };

  const tabItems = [
    {
      label: "Primary Details",
      key: 0,
      forceRender: true,
      children: (
        <div className="content-section-container color-7-section">
          <div className="row form-container" id="primary-details-form">
            <PrimaryDetails
              isFormEdit={isFormEdit}
              isFormHidden={isFormHidden}
              setIsFormDirty={setIsFormDirty}
              selectedTrailer={selectedTrailer}
              control={control}
              register={register}
              errors={errors}
              setValue={setValue}
              reset={reset}
            />
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <>
        <form id="trailer-form" onSubmit={handleSubmit(async (payload) => onSubmit(payload, false))}>
          <FormTabs
            items={tabItems}
            tabClassName="color-7"
            isFormHidden={isFormHidden}
          />

          <div className="row mt-5">
            <div className="col-12">
              <div className="d-flex flex-row align-items-center">
                <button className={`ms-auto btn btn-primary`} type="submit">
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </>
    </>
  );
}

export default TrailerForm;
